import type { CaseStatus } from './case-status';
import type { TagCode } from './tag-code';
import type { TransactionStatus } from './transaction-status';
import { CASE_STATUS_LABELS, CASE_STATUS_VALUES } from './case-status';
import { TAG_CODE_LABELS } from './tag-code';
import { TRANSACTION_STATUS_LABELS, TRANSACTION_STATUS_VALUES } from './transaction-status';

/** tags の 5 件（02 6.4 tagCode・要件書 5.2・F-26。display_order 1〜5） */
export const TAG_DEFINITIONS: ReadonlyArray<{
  tag_code: TagCode;
  tag_name: string;
  tag_color: string;
  display_order: number;
}> = [
  { tag_code: 'topPriority', tag_name: TAG_CODE_LABELS.topPriority, tag_color: '#E53935', display_order: 1 },
  { tag_code: 'major', tag_name: TAG_CODE_LABELS.major, tag_color: '#FB8C00', display_order: 2 },
  { tag_code: 'midTier', tag_name: TAG_CODE_LABELS.midTier, tag_color: '#1E88E5', display_order: 3 },
  { tag_code: 'newSmall', tag_name: TAG_CODE_LABELS.newSmall, tag_color: '#43A047', display_order: 4 },
  { tag_code: 'standby', tag_name: TAG_CODE_LABELS.standby, tag_color: '#9E9E9E', display_order: 5 },
];

/** case_statuses（274：旧PCRM の 6 値・並び。括弧の数字が display_order。成約＝is_won、失注＝is_lost） */
export const CASE_STATUS_DEFINITIONS: ReadonlyArray<{
  case_status: CaseStatus;
  case_status_name: string;
  display_order: number;
  is_won: boolean;
  is_lost: boolean;
}> = CASE_STATUS_VALUES.map((case_status, index) => ({
  case_status,
  case_status_name: CASE_STATUS_LABELS[case_status],
  display_order: index + 1,
  is_won: case_status === 'won',
  is_lost: case_status === 'lost',
}));

/**
 * transaction_statuses（02 6.4 transactionStatus）。274：旧PCRM の 7 段階（並びも旧と同じ）。
 * 新規の既定は先頭（アプローチ）。既に作った環境は seed を流し直し、消えた pending の行は 274-a4 のスクリプトで消す
 */
export const TRANSACTION_STATUS_DEFINITIONS: ReadonlyArray<{
  transaction_status: TransactionStatus;
  transaction_status_name: string;
  display_order: number;
}> = TRANSACTION_STATUS_VALUES.map((transaction_status, index) => ({
  transaction_status,
  transaction_status_name: TRANSACTION_STATUS_LABELS[transaction_status],
  display_order: index + 1,
}));

/** 失注として集計から除く固定の取引ステータス（要件書 5.4 の式・02 6.4） */
export const LOST_TRANSACTION_STATUS: TransactionStatus = 'lost';
